<template>
  <div class="container-main">
    <div class="container-main-header-button">
      <v-btn depressed @click="back">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <span>Редактирование кандидата</span>
    </div>
    <v-form ref="formFirst">
      <div class="container-block">
        <div class="container-block-title">Информация о кандидате</div>
        <div>
          <v-autocomplete
            label="ФИО"
            required
            type="text"
            outlined
            disabled
            :rules="rules"
            v-model="item"
            :items="[item]"
            :item-value="'id'"
            :item-text="'fullName'"
          ></v-autocomplete>
        </div>
        <div>
          <v-text-field
            label="Номер телефона"
            disabled
            type="text"
            outlined
            :rules="rules"
            v-model="item.phoneNumber"
          ></v-text-field>
        </div>

        <div>
          <v-textarea
            label="Биография"
            required
            no-resize
            type="text"
            outlined
            :rules="rules"
            v-model="item.bio"
            rows="10"
          ></v-textarea>
        </div>
      </div>
    </v-form>

    <div v-if="!imgSrc" class="container-block">
      <div class="container-block-title">Фотография акционера</div>

      <v-file-input
        accept="image/*"
        outlined
        :rules="[
          (value) =>
            (value && value.size < 104857600) ||
            'Размер изображения не больше 100 мб',
        ]"
        hint="Максимальный размер изображения 100 мб"
        persistent-hint
        v-model="newImage"
        @change="previewImage"
        ref="fileInput"
        label="Прикрепить изображение"
      ></v-file-input>
      <div class="container-block-gallery-button" @click="openGallery">
        Выбрать изображение из галереи
      </div>
    </div>

    <div></div>

    <div v-if="imgSrc" class="container-block" style="width: 100%">
      <div class="container-block-title">Кадрировать изображение</div>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Формат</th>
              <th class="text-left">Место отображенния</th>
              <th class="text-left">Для смартфонов</th>
              <th class="text-left">Для планшетов</th>
              <th class="text-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr style="height: 60px">
              <td class="text-left">Фото</td>
              <td class="text-left">
                Отображается в списке и разделе «Выборы КСА»
              </td>
              <td class="text-left">
                <v-btn
                  v-if="!imageSrcMobile"
                  @click="openMobileImg(false)"
                  class="button-accept"
                  style="width: auto !important"
                >
                  Кадрировать
                </v-btn>

                <div v-else class="d-flex">
                  <img
                    @click="openMobileImg(false)"
                    class="table-img"
                    :src="imageSrcMobile"
                  />
                  <v-btn
                    outlined
                    @click="openMobileImg(false)"
                    color="var(--app-dark-blue-1) "
                    class="button-accept-outlined"
                    style="width: auto !important; margin-left: 10px"
                  >
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn
                  v-if="!imageSrcTablet"
                  @click="openTabletImg(false)"
                  class="button-accept"
                  style="width: auto !important"
                >
                  Кадрировать
                </v-btn>
                <div v-else class="d-flex">
                  <img
                    @click="openTabletImg(false)"
                    class="table-img"
                    :src="imageSrcTablet"
                  />
                  <v-btn
                    outlined
                    @click="openTabletImg(false)"
                    color="var(--app-dark-blue-1) "
                    class="button-accept-outlined"
                    style="width: auto !important; margin-left: 10px"
                  >
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn icon @click="deleteImage">
                  <v-icon color="var(--app-red-1)"> mdi-delete-outline </v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-alert color="var(--app-red-1)" type="error" v-model="errImages">
        Откадрируйте изображения для всех типов устройств
      </v-alert>
      <v-divider></v-divider>

      <v-dialog
        width="800px"
        height="auto"
        persistent
        v-if="imgSrc"
        v-model="dialogMobile"
      >
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogMobile = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">
                Отображение на мобильном устройстве
              </div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrc" class="d-flex justify-space-between">
              <div style="width: 380px; height: 380px">
                <cropper
                  ref="cropperMobile"
                  :src="imgSrc"
                  style="width: 450px; height: 450px"
                  :stencil-props="{
                    handlers: {},
                    movable: false,
                    scalable: true,
                  }"
                  :stencil-size="{
                    width: 76,
                    height: 84,
                  }"
                  image-restriction="stencil"
                  @change="onChangeMobile"
                />
              </div>

              <div
                class="d-flex justify-center"
                style="width: 100%"
                v-if="resultImageMobile"
              >
                <img width="76px" height="84px" :src="resultImageMobile" />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeMobileImg()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        width="800px"
        height="auto"
        persistent
        v-if="imgSrc"
        v-model="dialogTablet"
      >
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogTablet = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">Отображение на планшете</div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrc" class="d-flex justify-space-between">
              <div style="width: 380px; height: 380px">
                <cropper
                  ref="cropperTablet"
                  :src="imgSrc"
                  style="width: 450px; height: 450px"
                  :stencil-props="{
                    handlers: {},
                    movable: false,
                    scalable: true,
                  }"
                  :stencil-size="{
                    width: 90,
                    height: 100,
                  }"
                  image-restriction="stencil"
                  @change="onChangeTablet"
                />
              </div>

              <div
                class="d-flex justify-center"
                style="width: 100%"
                v-if="resultImageTablet"
              >
                <img width="90px" height="100px" :src="resultImageTablet" />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeTabletImg()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-alert color="var(--app-red-1)" type="error" v-model="errImagesMain">
      Прикрепите изображение
    </v-alert>

    <div class="container-block-footer-buttons">
      <div>
        <v-btn
          @click="editCandidate"
          style="width: auto !important"
          class="button-accept"
        >
          Сохранить
        </v-btn>
      </div>
      <div></div>
    </div>
  </div>
</template>
<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
  components: {
    Cropper,
  },
  data: () => ({
    item: {},
    activities: [
      { name: "Должность", value: "" },
      { name: "С какого года", value: "" },
      { name: "Количество мероприятий", value: "" },
    ],

    errImages: false,
    errImagesMain: false,
    dialogMobile: false,
    dialogTablet: false,

    rules: [(value) => !!value || "Обязательно к заполнению"],

    newImage: null,
    imgSrc: "",

    resultImageMobile: "",
    resultImageTablet: "",

    finishImageMobile: "",
    finishImageTablet: "",

    imageSrcMobile: "",
    imageSrcTablet: "",

    smartphoneMainImage: null,
    tabletMainImage: null,
    formData: new FormData(),
    tempFormData: new FormData(),
  }),

  methods: {
    deleteImage() {
      this.imgSrc = "";
      this.imageSrcMobile = "";
      this.imageSrcTablet = "";
      this.resultImageMobile = "";
      this.resultImageTablet = "";
      this.finishImageMobile = "";
      this.finishImageTablet = "";
      this.smartphoneMainImage = null;
      this.tabletMainImage = null;
    },
    getFullName() {
      this.item.fullName = `${this.item.user.lastName} ${this.item.user.firstName} ${this.item.user.middleName}`;
    },
    openGallery() {
      this.$refs.fileInput.$el.querySelector("input").click();
    },

    openMobileImg() {
      this.dialogMobile = true;
      setTimeout(() => {
        this.$refs.cropperMobile.refresh();
      }, 500);

      this.errImages = false;
    },
    openTabletImg() {
      this.dialogTablet = true;
      setTimeout(() => {
        this.$refs.cropperTablet.refresh();
      }, 500);
      this.errImages = false;
    },
    getCandidate() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            "/ksa-election-candidates/" +
            this.$route.params.id,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          this.item = res.data;
          this.getFullName();
          this.itemPhoneNumber = this.phoneFormatRu(this.item.phoneNumber);
          this.imgSrc = this.item.image;
          this.imageSrcMobile = this.item.imageMobile;
          this.imageSrcTablet = this.item.imageTablet;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    closeTabletImg() {
      this.imageSrcTablet = this.resultImageTablet;
      this.dialogTablet = false;
      const { canvas } = this.$refs.cropperTablet.getResult();

      canvas.toBlob(
        (blob) => {
          this.formData.set("tabletImage", blob);
          this.finishImageTablet = blob;
          this.tabletMainImage = true;
        },
        "image/webp",
        0.95
      );
    },

    closeMobileImg() {
      this.imageSrcMobile = this.resultImageMobile;
      this.dialogMobile = false;

      const { canvas } = this.$refs.cropperMobile.getResult();
      canvas.toBlob(
        (blob) => {
          this.formData.set("smartphoneImage", blob);
          this.finishImageMobile = blob;
          this.smartphoneMainImage = true;
        },
        "image/webp",
        0.95
      );
    },

    async editCandidate() {
      if (!this.$refs.formFirst.validate()) return;

      if (!this.imgSrc) {
        this.errImagesMain = true;
        return;
      }

      if (!this.imageSrcMobile || !this.imageSrcTablet) {
        this.errImages = true;
        return;
      }

      const promises = [];
      if (this.newImage instanceof File || this.newImage instanceof Blob) {
        promises.push(this.uploadImage(this.newImage));
      }
      if (typeof this.finishImageMobile !== "string") {
        promises.push(this.uploadImage(this.finishImageMobile));
      }
      if (typeof this.finishImageTablet !== "string") {
        promises.push(this.uploadImage(this.finishImageTablet));
      }

      try {
        const [image, smartphoneImage, tabletImage] = await Promise.all(
          promises
        );

        this.candidate = {
          id: this.item.id,
          userId: this.item.userId,
          phoneNumber: this.item.phoneNumber,
          bio: this.item.bio,
          image: image || this.item.image,
          imageMobile: smartphoneImage ?? this.item.imageMobile,
          imageTablet: tabletImage ?? this.item.imageTablet,
        };

        await this.$axios
          .patch(
            this.$store.getters.apiAdminPanelV5 + "/ksa-election-candidates",
            this.candidate,
            {
              headers: {
                authorization: this.$store.getters.adminPanelHeaderAuth,
                "secret-key": this.$store.state.secretKeyCookie,
              },
            }
          )
          .then(() => {
            this.$store.commit("errorSet", {
              key: true,
              text: "Кандидат успешно обновлен",
              type: "success",
            });
          });
        this.getCandidate();
      } catch (err) {
        this.$store.commit("errorSet", true);
        this.$store.commit("errorTextSet", err);
      }
    },

    back() {
      this.$router.go(-1);
    },

    async uploadImage(image) {
      const formData = new FormData();
      formData.append("file", image);
      formData.append("path", "candidateKSA");

      const { data } = await this.$axios.post(
        this.$store.getters.apiAdminPanelV5 + "/upload",
        formData,
        {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
            "secret-key": this.$store.state.secretKeyCookie,
          },
        }
      );

      return data;
    },

    previewImage() {
      if (this.newImage) {
        this.imgSrc = URL.createObjectURL(this.newImage);
      } else {
        this.imgSrc = "";
      }
    },

    defaultSize({ imageSize }) {
      return {
        width: Math.min(imageSize.height, imageSize.width),
        height: Math.min(imageSize.height, imageSize.width),
      };
    },

    onChangeMobile({ canvas }) {
      this.resultImageMobile = canvas.toDataURL();
    },

    onChangeTablet({ canvas }) {
      this.resultImageTablet = canvas.toDataURL();
    },
  },
  created() {
    this.getCandidate();
  },

  watch: {
    newImage() {
      if (this.newImage) {
        this.errImagesMain = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container-main {
  box-sizing: border-box;

  padding: 40px !important;

  .container-main-header-button {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    span {
      font-size: 28px;
      font-weight: 400;
      margin-left: 16px;
    }
  }

  .container-block {
    width: 50%;
    margin-bottom: 20px;

    .container-block-title {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 16px;
    }

    .container-block-gallery-button {
      text-decoration: underline;
      color: #1064dd;
      font-size: 18px;
      font-weight: 400;
      cursor: pointer;
      padding-bottom: 20px;
    }

    .table-img {
      // width: 62px;
      height: 38px;
      object-fit: contain;
    }
  }

  .container-block-footer-buttons {
    display: flex;
    justify-content: space-between;
    width: 50%;
    margin-top: 60px;
  }
}

.dialog-tablet-img {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  img {
    width: 658;
    height: 192;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}
</style>
